import { getFormValues } from "redux-form";
import { createSelector } from "reselect";

const emptyObj = {};

export const getSearchProductDetails = form =>
  createSelector(getFormValues(form), data => data || emptyObj);
